import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./slices/productSlice";
import productDetailsReducer from "./slices/productDetailsSlice";
import authReducer from "./slices/authSlice";
const store = configureStore({
  reducer: {
    products: productReducer,
     productDetails: productDetailsReducer,
     auth: authReducer,
  },
});

export default store;
